// Lightweight SEO helper for a client-rendered SPA: sets title + meta description + OG tags.
export function setSeo({ title, description, image } = {}) {
  if (title) document.title = title;
  const set = (selector, attr, value) => {
    if (!value) return;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
      el.setAttribute(k, v.replace(/["']/g, ""));
      document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
  };
  set('meta[name="description"]', "content", description);
  set('meta[property="og:title"]', "content", title);
  set('meta[property="og:description"]', "content", description);
  set('meta[property="og:image"]', "content", image);
}

// Canonical host is non-www (www 308-redirects to it). Used by <RouteSeo>.
export const SITE_URL = "https://pulalove.com";
